import { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import Button from "/components/common/button";
import Link from "next/link";
import styles from "./index.module.scss";
import { getType } from "../../../../utils";

export default function Selector({ sectionPageUrl }) {
  const { marks, topMarks, models, types } = useSelector(
    (state) => state.models,
  );
  const marksMap = marks ?? {};
  const topMarksList = Array.isArray(topMarks) ? topMarks : [];
  const modelsMap = models ?? {};
  const typesMap = types ?? {};
  const [showAllMarks, setShowAllMarks] = useState(false);
  const { params } = useSelector((state) => state.filter);

  const marksFiltered = useMemo(() => {
    const topMarksCodes = Object.keys(marksMap);
    return topMarksList.filter((mark) => topMarksCodes.includes(mark.CODE));
  }, [marksMap, topMarksList]);

  const marksRecomended = useMemo(() => {
    let marksRecomended = marksFiltered.filter((mark) => mark.RECOMENDED);
    const remain = marksRecomended.length % 5;
    if (remain > 0 && marksRecomended.length > 5) {
      marksRecomended = marksRecomended.slice(
        0,
        Math.floor(marksRecomended.length / 5) * 5,
      );
    }

    return marksRecomended;
  }, [marksFiltered]);

  const marksBySymbol = useMemo(() => {
    const result = {};
    // eslint-disable-next-line array-callback-return
    marksFiltered.map((mark) => {
      if (!result[mark.NAME[0]]) {
        result[mark.NAME[0]] = [];
      }
      result[mark.NAME[0]].push(mark);
    });
    return result;
  }, [marksFiltered]);

  const steps = {
    mark: "mark",
    model: "model",
    type: "type",
  };

  const currentStep = useMemo(() => {
    if (Object.keys(modelsMap).length === 0) {
      return steps.mark;
    }
    if (Object.keys(typesMap).length === 0) {
      return steps.model;
    }
    return steps.type;
  }, [modelsMap, typesMap]);

  const title = useMemo(() => {
    if (currentStep === steps.mark) {
      return "Выберите марку";
    }
    if (currentStep === steps.model) {
      return "Выберите модель";
    }
    return "Выберите тип кузова";
  }, [currentStep]);

  const symbolsH = useMemo(() => {
    let count = 0;
    Object.values(marksBySymbol).forEach((marks) => {
      count += marks.length;
    });
    return count * 19;
  }, [marksBySymbol]);

  return params.kuzov?.[0] || marksFiltered.length === 0 ? null : (
    <div className={styles.Selector} id="selector">
      <div className={styles.Title}>{title}:</div>
      {showAllMarks && currentStep === steps.mark && (
        <div className={styles.Symbols} style={{ height: symbolsH }}>
          {Object.keys(marksBySymbol).map((symbol) => (
            <div className={styles.Symbol} key={symbol}>
              <span>{symbol}</span>
              <ul className={styles.Marks}>
                {marksBySymbol[symbol].map((mark) => (
                  <Link
                    key={mark.ID}
                    href={`${sectionPageUrl}filter/marka-${mark.CODE}/`}
                  >
                    <a>
                      <img src={mark.PICTURE_SRC} />
                      <span>{mark.NAME}</span>
                    </a>
                  </Link>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
      {!showAllMarks && currentStep === steps.mark && (
        <div>
          <ul className={styles.TopMarks}>
            {marksFiltered
              .filter((mark) => mark.TOP)
              .map((mark) => (
                <li key={mark.ID}>
                  <Link href={`${sectionPageUrl}filter/marka-${mark.CODE}/`}>
                    <img src={mark.PICTURE_SRC} />
                  </Link>
                </li>
              ))}
          </ul>
          <ul className={clsx(styles.Items, styles.ItemsMarks)}>
            {marksRecomended.map((mark) => (
              <li key={mark.ID}>
                <Link href={`${sectionPageUrl}filter/marka-${mark.CODE}/`}>
                  {mark.NAME}
                </Link>
              </li>
            ))}
          </ul>
          <Button
            label={"Показать все марки"}
            onClick={() => {
              setShowAllMarks(true);
            }}
          />
        </div>
      )}
      {currentStep === steps.model && (
        <ul className={styles.Items}>
          {Object.keys(modelsMap)
            .sort()
            .map((modelCode) => (
              <li key={modelCode}>
                <Link
                  href={`${sectionPageUrl}filter/marka-${params.marka[0]}/model-${modelCode}/`}
                >
                  {modelsMap[modelCode].NAME}
                </Link>
              </li>
            ))}
        </ul>
      )}
      {currentStep === steps.type && (
        <ul className={clsx(styles.Items, styles.TypesItems)}>
          {Object.keys(typesMap)
            .map((typeCode) => getType(typesMap[typeCode].NAME, typeCode))
            .sort((a, b) => a.sort - b.sort)
            .map((item) => (
              <li key={item.code}>
                <Link
                  href={`${sectionPageUrl}filter/marka-${params.marka[0]}/model-${params.model[0]}/kuzov-${item.code}/`}
                >
                  <a>
                    <span>{item.name}</span>
                    {item.gen && <div className={styles.Gen}>{item.gen}</div>}
                  </a>
                </Link>
              </li>
            ))}
        </ul>
      )}
    </div>
  );
}
